import { ApplicationsTable } from '@features/applications'
import { withTableView } from '@components/enitity/table/Table.view'
import { useTranslation } from 'react-i18next'

export const Applications = () => {
  const { t } = useTranslation('application')

  const TableWithView = withTableView(
    ApplicationsTable,
    t('form.labels.applications')
  )

  return <TableWithView />
}
